import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  dark: {
    name: 'Dark',
    bgGradient: 'bg-gradient-to-br from-[#0a1628] via-[#0d1b2a] to-[#0a1628]',
    text: 'text-white',
    textSecondary: 'text-gray-400',
    card: 'bg-gray-800/40',
    cardBorder: 'border-gray-700/50',
    input: 'bg-gray-900/50 border-gray-700/50 text-gray-300 placeholder-gray-500',
    inputBg: 'bg-gray-900/50',
    button: 'bg-cyan-500 hover:bg-cyan-600',
    buttonSecondary: 'bg-gray-800/50 hover:bg-gray-700/50',
    textarea: 'bg-gray-800/30 border-gray-700/50',
    iconPrimary: 'text-cyan-400',
    iconSecondary: 'text-gray-400',
  },
  light: {
    name: 'Light',
    bgGradient: 'bg-gradient-to-br from-slate-50 via-blue-50/20 to-slate-100',
    text: 'text-slate-900',
    textSecondary: 'text-slate-600',
    card: 'bg-white/80',
    cardBorder: 'border-slate-200',
    input: 'bg-white border-slate-200 text-slate-900 placeholder-slate-400',
    inputBg: 'bg-slate-50/50',
    button: 'bg-gradient-to-r from-blue-600 to-cyan-500',
    buttonSecondary: 'bg-slate-100 hover:bg-slate-200',
    textarea: 'bg-white border-slate-200',
    iconPrimary: 'text-blue-600',
    iconSecondary: 'text-slate-500',
  },
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState('dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('cyborx_theme');
    if (savedTheme && themes[savedTheme]) {
      setThemeState(savedTheme);
    }
  }, []);

  const setTheme = (newTheme) => {
    setThemeState(newTheme);
    localStorage.setItem('cyborx_theme', newTheme);
  };

  const isDark = theme !== 'light';

  return (
    <ThemeContext.Provider value={{ theme, setTheme, isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
